import {Component, AfterViewInit, OnChanges, DoCheck} from '@angular/core';

import {DataService} from '../data.service';
import {ShelfElement} from '../shelf-element';
import {ShelfElementListEntry} from '../shelf-element-list-entry';
import { ShelfElementService } from '../shelf-element.service';


@Component({
  selector: 'app-element-list',
  templateUrl: './element-list.component.html',
  styleUrls: ['./element-list.component.css']
})
export class ElementListComponent implements AfterViewInit {

    public shelfElements: ShelfElement[];

    public shelfElementsOnScene: ShelfElementListEntry[];

    constructor(private dataService: DataService, private shelfElementService: ShelfElementService) {
        this.shelfElementsOnScene = new Array();
    }

    getShelfElements(): void {
        this.shelfElementService.getShelfElements().subscribe(shelfElements => this.shelfElements = shelfElements);
    }

    ngAfterViewInit() {
        this.getShelfElements();
    }


    updateElementList() {
      const elementCountList = this.dataService.getSharedData('elementCountList');
      //console.log('update Elements');
      //console.log(elementCountList);
      if (this.shelfElements === undefined) {
          this.getShelfElements();
      }
        this.shelfElementsOnScene = new Array();
        for (let index = 0; index < this.shelfElements.length ; index++ ) {
          const shelfElement = this.shelfElements[index];
          if (elementCountList.has(shelfElement.articleNumber)) {
              const countElement = elementCountList.get(shelfElement.articleNumber)
              this.shelfElementsOnScene.push(new ShelfElementListEntry(shelfElement, countElement));
          }
      }
    }

    valuechange(inputTextfield) {
        //console.log(inputTextfield.id);
        //console.log(inputTextfield.value);
        const elementCountList = this.dataService.getSharedData('elementCountList');
        if (inputTextfield.value >0) {
            elementCountList.set(inputTextfield.id, inputTextfield.value);
            this.dataService.shareData('elementCountList', elementCountList);
        }


    }



}



// WEBPACK FOOTER //
// ./src/app/element-list/element-list.component.ts